<template>
  <div class="container">
    <h5>{{ t('saladGeneratorTitle') }}</h5>
    <p>{{ t('saladGeneratorDescription') }}</p>
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput :inputLabel="t('oneTHCTo')" v-model.number="cbdRatio" :unit="t('cbdUnit')" />
        <FixedUnitInput :inputLabel="t('maxElements')" v-model.number="maxElements" unit="" />
        <FixedUnitInput :inputLabel="t('minimumTHC')" v-model.number="minThc" :unit="t('percent')" />
        <hr />
        <template v-for="i in 4" :key="i">
          <FixedUnitInput :inputLabel="`${productLabel} ${i}`" v-model.number="products[i - 1].weight" :unit="t('grams')" />
          <FixedUnitInput :inputLabel="t('thcPercentage')" v-model.number="products[i - 1].thc" :unit="t('percentTHC')" />
          <FixedUnitInput :inputLabel="t('cbdPercentage')" v-model.number="products[i - 1].cbd" :unit="t('percentCBD')" />
        </template>
      </div>
      <div class="col-sm">
        <ul v-if="getCombos.length">
          <li v-for="(combo, index) in getCombos" :key="index">
            1THC:{{ combo.cbdRatio }}CBD ({{ combo.thc }}% THC, {{ combo.cbd }}% CBD)
            <ul>
              <li v-for="(comboEntry, entryIndex) in combo.combination" :key="entryIndex">
                {{ comboEntry.weight }}g {{ comboEntry.thc }}% THC, {{ comboEntry.cbd }}% CBD
              </li>
            </ul>
          </li>
        </ul>
        <h5 v-else>{{ t('cantMakeBlend') }}</h5>
      </div>
    </div>
  </div>
</template>

  
  <script>
    import { ref, computed, reactive, watchEffect } from 'vue';  
    import FixedUnitInput from '../inputs/FixedUnitInput.vue'; // Ensure this path is correct
    import { useI18n } from 'vue-i18n';


    export default {
        components: {
        FixedUnitInput,
        },
        setup() {
    
            const cbdRatio = ref(1.5);
            const maxElements = ref(4);
            const minThc = ref(7);

            const { t } = useI18n();

            const productLabel= ref(t("productLabel"));

            watchEffect(() => {
              productLabel.value = t("productLabel");
            });

             // Create a reactive object with a function
            const translations = reactive({
              t: (key) => t(key)
            })

            //const products = ref(Array.from({ length: 4 }, () => ({ weight: 0, thc: 0, cbd: 0 })));
            const products = ref([
                { weight: 0, thc: 0, cbd: 0 },
                { weight: 0, thc: 0, cbd: 0 },
                { weight: 0, thc: 0, cbd: 0 },
                { weight: 0, thc: 0, cbd: 0 }
                ]);
            // const product1Weight = ref(0);
            // const product1THC = ref(0);
            // const product1CBD = ref(0);
            // const product2Weight = ref(0);
            // const product2THC = ref(0);
            // const product2CBD = ref(0);
            // const product3Weight = ref(0);
            // const product3THC = ref(0);
            // const product3CBD = ref(0);
            // const product4Weight = ref(0);
            // const product4THC = ref(0);
            // const product4CBD = ref(0);

            // Utility function to calculate combinations with repetitions
            function combRep(arr, l) {
                if (l === void 0) l = arr.length;
                let data = Array(l), results = [];
                (function f(pos, start) {
                if (pos === l) {
                    results.push(data.slice());
                    return;
                }
                for (let i = start; i < arr.length; ++i) {
                    data[pos] = arr[i];
                    f(pos + 1, i);
                }
                })(0, 0);
                return results;
            }

            // Utility function for rounding
            function defaultRound(value) {
                return Math.round(value * 100) / 100; // Adjust rounding as needed
            }
            
            // // Logic to get array of options
            function getArrayOfOptions() {
                return products.value.filter(p => p.weight !== 0);
            }

            

             // Logic to compute the combinations
            const getCombos = computed ( () =>{
                let combinations = combRep(getArrayOfOptions(), maxElements.value);
                const distance = (a, t) => Math.abs(t - a);
            
                let noZeroAmts = combinations
                .map(option => option.filter(details => details.weight > 0))
                .filter(combination => combination.length > 0);
            
                return noZeroAmts
                    .map(combo => ({
                        combination: combo.filter(constituent => constituent.weight > 0),
                        thc: defaultRound(
                        combo.reduce((accum, curr) => accum + curr.thc * curr.weight, 0) /
                            combo.reduce((accum, curr) => accum + curr.weight, 0)
                        ),
                        cbd: defaultRound(
                        combo.reduce((accum, curr) => accum + curr.cbd * curr.weight, 0) /
                            combo.reduce((accum, curr) => accum + curr.weight, 0)
                        ),
                        cbdRatio: defaultRound(
                        combo.reduce((accum, curr) => accum + curr.cbd * curr.weight, 0) /
                            combo.reduce((accum, curr) => accum + curr.thc * curr.weight, 0) || 0
                        ),
                    }))
                    .filter(combo => combo.thc >= minThc.value)
                    .sort(
                        (a, b) => {
                            let ratioDistance = distance(a.cbdRatio, cbdRatio.value) - distance(b.cbdRatio, cbdRatio.value);
                            if (ratioDistance == 0) {
                                return a.combination.length - b.combination.length;
                            }

                            return ratioDistance;
                        }
                        
                        )
                    .slice(0, 5);


            });
            
            return {
                cbdRatio,
                maxElements,
                minThc,
                products,
                getCombos,
                t: translations.t,
                productLabel
            };

        }

    }


  
  
  
  
 




      </script>
  